import React from 'react';
import ReactDOM from 'react-dom';
import Axios from 'axios';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/core/styles';
import { getTheme } from '@/theme';
import configureStore from '@/store';
import { setupMock } from '@/app.mock';
import { axiosHelper } from '@/utils/axios/axios.helper';
import { setHistory } from '@/utils/history.util';
import { AppRootContainer } from '@/shared/app-root/app-root.container';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import { SnackbarProvider } from 'notistack';
//Importing selected icons using treeshaking technic
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faFootballBall,
  faCrown,
  faSackDollar,
  faMoneyBillWaveAlt,
  faShareSquare,
  faEnvelopeOpen,
  faComment,
  faStopwatch,
  faDice,
  faHorseHead,
  faGift,
  faUserFriends,
  faQuestion,
  faUser,
  faBars,
  faCheckCircle,
  faTimesOctagon,
  faUserEdit,
  faListOl,
  faCircleArrowLeft,
  faCircleArrowRight,
  faLayerPlus,
  faArrowDown,
  faArrowUp,
  faPlusCircle,
} from '@fortawesome/pro-duotone-svg-icons';
import { forceUpdateAppSettings, setAppSettings } from '@/utils';

library.add(
  faCrown,
  faFootballBall,
  faStopwatch,
  faDice,
  faHorseHead,
  faGift,
  faUserFriends,
  faQuestion,
  faUser,
  faBars,
  faCheckCircle,
  faTimesOctagon,
  faUserEdit,
  faSackDollar,
  faMoneyBillWaveAlt,
  faShareSquare,
  faEnvelopeOpen,
  faComment,
  faListOl,
  faCircleArrowLeft,
  faCircleArrowRight,
  faLayerPlus,
  faArrowDown,
  faArrowUp,
  faPlusCircle,
);

export function main(appId: string, appSettings: any): any {
  if (!appSettings) forceUpdateAppSettings();
  else setAppSettings(appSettings);
  const appAxios = Axios.create();
  axiosHelper.setAxios(appAxios);

  const isMock = window && window.location.href.split('#')[0].indexOf('mock=1') !== -1;
  if (isMock) {
    // Use mock data
    setupMock(appAxios);
  }

  const history = setHistory();

  const initialState: any = {};
  const store: any = configureStore(initialState, history);

  const MOUNT_NODE = document.getElementById('root');
  if (!MOUNT_NODE) {
    return;
  }
  const darkMode = true;

  // const isAppAvailable =
  //   !isMaintenance('2025-04-07 23:00', '2025-04-08 07:00') ||
  //   (isMaintenance('2025-04-07 23:00', '2025-04-08 07:00') && window.location.href.includes('secret=34471e6d'));

  const render = (): void => {
    ReactDOM.render(
      <Provider store={store}>
        <ThemeProvider theme={getTheme(darkMode)}>
          {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
          <CssBaseline />
          <ConnectedRouter history={history}>
            <SnackbarProvider
              maxSnack={10}
              style={{
                backgroundColor: '#2d2d2d',
                color: 'white',
                border: '1px solid #c8a964',
                maxWidth: '500px',
                minWidth: '300px',
              }}
            >
              <AppRootContainer />
            </SnackbarProvider>
          </ConnectedRouter>
        </ThemeProvider>
      </Provider>,
      MOUNT_NODE,
    );
  };

  /* istanbul ignore next */
  // if (process.env.NODE_ENV === 'development') {
  //   if (module.hot) {
  //     module.hot.accept('./shared/app-root/app-root.component', () => {
  //       ReactDOM.unmountComponentAtNode(MOUNT_NODE);
  //       render();
  //     });
  //   }
  // }

  render();
}
